function subpage() {
	const mainSubpage = document.querySelector('main.subpage');
	if (!mainSubpage) return;

	// Modules code
	// moduleCards();
	// moduleContentColumns();
	// moduleContentWithImage();
	// moduleContentWithSideCards();
	moduleContentWithSlides();
	// moduleFaq();
	// moduleFeaturedArticles();
	moduleForm();
	// moduleFilesToDownload();
	moduleMapWithPoints();
	// moduleMedia();
	// moduleNewsletter();
	// modulePeople();
	// moduleProductDetails();
	// moduleProductSteps();
	// moduleSectionTitle();
	// moduleSmallSections();
	// moduleStepsWithList();
	// moduleSupportSection();
	// moduleTabsWithImage();
	// moduleTilesWithExpandableImages();
}
